import updatePassword from './update-password/update-password.vue';
import {
    logout
} from 'src/api/common.api.js';

export default {
    data () {
        return {
            userName: '',
            updatePassowrdVisible: false
        };
    },
    components: {
        updatePassword
    },
    created () {
        let that = this,
            user = JSON.parse(localStorage.getItem('user') || '[]'),
            userName = user.username;

        that.userName = userName;
    },
    methods: {
        /**
         * [updatePasswordHandle 修改密码]
         * @return {[type]} [description]
         */
        updatePasswordHandle: function () {
            let that = this;

            that.updatePassowrdVisible = true;
            that.$nextTick(function () {
                that.$refs.updatePassowrd.init(that.userName);
            });
        },

        /**
         * [logoutHandle 退出登录]
         * @return {[type]} [description]
         */
        logoutHandle: function () {
            let that = this,
                common = that.common,
                serve = common.serve.http;

            that.$confirm(`确定进行[退出]操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                serve.httpRequest({}, logout, _cb);
            });

            function _cb (res) {
                if (res.code === 0) {
                    localStorage.removeItem('token');
                    that.$router.push({name: 'login'});
                } else {
                    that.$message.error(res.msg);
                }
            }
        },

        openScreen () {
            let that = this;

            that.$router.push({name: 'bigScreen'});
        }
    }
};


// WEBPACK FOOTER //
// ./src/views/common/home/home-nav-bar/home.nav.bar.js